import React, { useEffect, useState } from "react";
import hipladeTemplate from "../../common/template";
import DataIa from "../components/DataIa";
import { Box, Button } from "@mui/material";
import Banner from "../../common/components/banner";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import UsersService from "../../services/UsersService";
import AvatarHiplade from "../../common/components/avatarhiplade";

function EventDataIa() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { eventId, userId, debriefingId } = useParams();
  const checklistId = searchParams.get("checklistId") || undefined;
  const [user, setUser] = useState({} as any);

  const loadUser = async (id: any) => {
    await UsersService.get(id)
      .then((response: any) => {
        if (response) {
          setUser(response.data);
        }
      })
      .catch((e: Error) => {});
  };

  useEffect(() => {
    if (userId) {
      loadUser(userId);
    }
  }, [eventId, userId]);

  const backEvent = (eventId: any) => {
    navigate("/events/data-ai/" + eventId);
  };

  return (
    <Box>
      <Banner
        type="student"
        title={t("description_event_scenario_view") + (user?.name || `Aluno #${userId}`)}
        avatar={<AvatarHiplade nameUser={user?.name || `Aluno #${userId}`} id={user?.id || userId} size="lg" />}
        button={
          <Button
            variant="contained"
            color="secondary"
            onClick={() => backEvent(eventId)}
          >
            {t("btn_return")}
          </Button>
        }
      />
      <DataIa
        eventId={eventId}
        idEvaluated={userId}
        idDebriefing={debriefingId}
        checklistId={checklistId}
      />
    </Box>
  );
}

export default hipladeTemplate(EventDataIa);
